import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";

/**
 * @name CaptureFirstLoginLoginPage
 * @returns {React.Component}
 * @description Capture component to show the login page without anything filled out
 * for the first time login group
 */
export default function CaptureFirstLoginLoginPage(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "")
    .update([ "password" ], "")
    .submit();

    return <LoginPage data={ data } />
}